import { useEffect } from "react";

const SPRITE_URL = `${import.meta.env.BASE_URL}svg/sprite.svg`;

/** Injects Cuba icon sprite into the DOM so sidebar/header `<use href="#id">` resolves reliably. */
export default function SpriteSheet() {
  useEffect(() => {
    if (document.getElementById("credora-svg-sprite")) {
      return;
    }

    let cancelled = false;

    fetch(SPRITE_URL)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Sprite load failed: ${res.status}`);
        }
        return res.text();
      })
      .then((markup) => {
        if (cancelled) {
          return;
        }
        const host = document.createElement("div");
        host.id = "credora-svg-sprite";
        host.setAttribute("aria-hidden", "true");
        host.style.cssText = "position:absolute;width:0;height:0;overflow:hidden;visibility:hidden";
        host.innerHTML = markup;
        document.body.prepend(host);
        window.__CREDORA_SPRITE_READY__ = true;
        window.dispatchEvent(new Event("credora-sprite-ready"));
      })
      .catch((err) => {
        console.warn("[SpriteSheet]", err);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
